import React from 'react'

function SkillsIcon(props) {
  const { icon } = props
  return(
    <div className="icon-container">
      <img
        className="icons"
        src={icon.image}
        alt="Images of different coding languages"
      />
      <h4>{icon.title}</h4>
    </div>
  )
}

export default SkillsIcon
